import script from "./EmailLogsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailLogsModal.vue?vue&type=script&lang=ts&setup=true"

import "./EmailLogsModal.vue?vue&type=style&index=0&id=20358a31&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20358a31"]])

export default __exports__